import { IconProps } from '@drift-labs/icons';
import { cj } from 'src/utils/classNames';

export default function Google({ className, size = 16, ...props }: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 16 16"
				fill="none"
			>
				<rect width="16" height="16" rx="8" fill="white" />
				<path
					d="M13.096 8.11966C13.096 7.74766 13.064 7.39566 13 7.05566H8.104V9.06766H10.904C10.8438 9.38554 10.7199 9.68794 10.5398 9.95671C10.3597 10.2255 10.1271 10.4551 9.856 10.6317V11.9437H11.544C12.528 11.0357 13.096 9.70366 13.096 8.11966Z"
					fill="#4285F4"
				/>
				<path
					d="M8.10396 13.2002C9.36886 13.2357 10.5995 12.7863 11.544 11.9442L9.85596 10.6322C9.33578 10.9722 8.72531 11.1478 8.10396 11.1362C7.45543 11.1279 6.8258 10.9166 6.30351 10.532C5.78122 10.1475 5.3925 9.60899 5.19196 8.99219H3.45996V10.3362C3.89239 11.1972 4.5557 11.921 5.3758 12.4268C6.19589 12.9325 7.14046 13.2003 8.10396 13.2002Z"
					fill="#34A853"
				/>
				<path
					d="M5.19209 8.98797C4.97772 8.34675 4.97772 7.65319 5.19209 7.01197V5.66797H3.46009C3.09203 6.39022 2.90015 7.18934 2.90015 7.99997C2.90015 8.8106 3.09203 9.60972 3.46009 10.332L4.80809 9.27997L5.19209 8.98797Z"
					fill="#FBBC05"
				/>
				<path
					d="M8.10411 4.87217C8.84328 4.86044 9.5579 5.13739 10.0961 5.64417L11.5841 4.15618C10.6435 3.27056 9.39595 2.78445 8.10411 2.80017C6.07211 2.80017 4.31611 3.96817 3.46411 5.66817L5.19211 7.01218C5.39334 6.39612 5.78234 5.8585 6.30458 5.47471C6.82681 5.09093 7.45607 4.88023 8.10411 4.87217Z"
					fill="#EA4335"
				/>
			</svg>
		</span>
	);
}
